import React from 'react'
import _ from 'lodash'
import { Label, coreUtils } from '@adc/ui-morpheus'
const { ColorHash } = coreUtils
const colorHash = new ColorHash()

/**
 * Renders one dropdown option
 * @param  {string} prefix=''       Prefix to show e.g. "(RESI) "
 * @param  {string} label           Label of option
 * @param  {string} description=''  Subtext below label
 */
const renderResult = (prefix = '', label, description = '') => (
  <div>
    <Label
      style={{
        backgroundColor: colorHash.hex(label),
        color: '#fff',
      }}
      content={`${prefix}${label}`}
    />
    {description && <p>{description}</p>}
  </div>
)

/**
 * Renders role options
 * @param  {Array} roleDefs   Array of roledef objects
 */
export const renderOptions = (roleDefs = []) =>
  roleDefs.map(item => ({
    value: item.role_code,
    text: item.role_display_name,
    content: renderResult('', item.role_display_name, item.role_desc),
  }))

/**
 * Renders suggestion options
 * @param  {Array} roleDefs   Array of roledef objects
 */
export const renderSuggestions = roleDefs =>
  roleDefs.map(item => {
    const prefix =
      item.lob_code === 'RESIDENTIAL' // eslint-disable-line
        ? '(RESI) '
        : item.lob_code === 'COMMERCIAL'
        ? '(CRE) '
        : ''

    return {
      value: item.role_code,
      text: `${prefix}${item.role_display_name}`,
      content: renderResult(prefix, item.role_display_name),
    }
  })

/**
 * This is to emulate what we'd otherwise (typically) get from a one time async suggestion fetch,
 * however in this case we grab it from the store and construct the suggestion options here.
 */
export const prepRoleSuggestions = roleDefs => ({
  'security.roles': renderSuggestions(roleDefs),
})

/**
 * Determines if simple string array of role codes contains roles that are not RESI
 */
export const areRolesResiOnly = (roles, roleDefs) =>
  !_.find(roles, role => {
    const roleDef = _.find(roleDefs, { role_code: role })
    if (!roleDef) return true
    if (roleDef.lob_code !== 'RESIDENTIAL') return true
  })

export const filterRolesResiOnly = roleDefs =>
  _.filter(roleDefs, { lob_code: 'RESIDENTIAL' })
